import React from 'react'
import './NotFoundPage.css'

export const NotFoundPage = () => {
  return (
    <div className="not-found-container">
      <div className="contents">
        <div className="error-container">
          <h1 className="error-code">404</h1>
          <div className="floating-circle"></div>
        </div>
        
        <div className="message">
          <h2>Page Not Found</h2>
          <p>
            Oops! The page you're looking for seems to have wandered off into the digital wilderness.
          </p>
        </div>
        
        <button onClick={() => window.history.back()} className="back-button">
          Go Back
        </button>

        <div className="decorative-bars">
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      </div>
    </div>
  );
}

